module.exports = __webpack_public_path__ + "static/media/mawaqif.cb02636f.png";